const setCookie = (name, value, Days, domain) => {
  if (typeof (Days) == 'undefined')
    Days = 1;
  if (typeof (domain) == 'undefined') {
    domain = "";
  }
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + encodeURIComponent(value) + ";" +
    (Days > 0 ? "expires=" + exp.toGMTString() : "") +
    ";" + "domain=" + domain + ";path=/;";
}

const getCookie = (name) => {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return decodeURIComponent(arr[2]);
  else
    return null;
}

const delCookie = (name, domain) => {
  if (typeof (domain) == 'undefined') {
    domain = "";
  }
  var exp = new Date();
  exp.setTime(exp.getTime() - 86400 * 7);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=delete;expires=" + exp.toGMTString() + ";domain=" + domain + ";path=/;";
}



export {
  setCookie,
  getCookie,
  delCookie
}



// WEBPACK FOOTER //
// ./src/assets/js/cookie.js